















// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import _isEmpty from "lodash/isEmpty";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "qError",
})
export default class qError extends Vue {
  @Prop({
    default: () => {
      return {};
    },
  })
  public errors;
  @Prop() public name: string;
  @Prop({
    default: () => {
      return {
        maxWidth: "auto",
      };
    },
  })
  public errorStyle;
  @Prop({
    default: () => {
      return "mb__error";
    },
  })
  public classError;

  get totalMessages() {
    return Object.keys(this.messages).length;
  }

  get messages(): any {
    if (_isEmpty(this.errors)) {
      return {};
    }
    if (this.name) {
      if (this.name in this.errors) {
        return this.errors[this.name];
      }
      const keys = this.name.split(".");
      let current = this.errors;
      for (const value of keys) {
        current = current[value] || [];
      }
      return current;
    } else if (!(this.name in this.errors)) {
      return {};
    } else {
      return this.flatten(this.errors);
    }
  }

  public traverseAndFlatten(currentNode, target, flattenedKey) {
    for (const key in currentNode) {
      if (key in currentNode) {
        const newKey = flattenedKey === null ? key : flattenedKey + "." + key;
        const value = currentNode[key];
        if (typeof value === "object") {
          this.traverseAndFlatten(value, target, newKey);
        } else {
          target[newKey] = value;
        }
      }
    }
  }

  public flatten(object) {
    const flattenedObject = {};
    this.traverseAndFlatten(object, flattenedObject, null);
    return flattenedObject;
  }

  get getStyle(): any {
    return this.errorStyle;
  }
}
